<template>
	<div id="superuser">
		<div class="row">
			<div class="col-12">
				<p class="mb-4">To login as another user, click the Generate button and a new Super User Password will be generated.<br>
								Use this password with any Email Address to login in one time as that user.</p>
				<el-input readonly="readonly" size="default" class="password" v-model="password" />
				<button class="btn btn-icon btn-warning" @click="generatePassword">
					<i class="fas fa-lock-open"></i>  <span>Generate Password</span>
				</button>
			</div>
		</div>
		<div class="row mt-4">
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import axios from 'axios';
	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

	export default {
		name: 'SuperUserPassword',
		data() {
			return {
				password : '',
			}
		},
		props:["config"],

		methods: {
			generatePassword() {
				axios.post('/users/generatesuperuserpassword', {},
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.password = response.data.password;
						} else {
						}
					}).catch(response => {
				});
			},
		}
	}
</script>


<style scoped>
	.password {
		width: 200px;
		margin-bottom: 5px;
		margin-right: 20px;
		-webkit-user-select: all;
		-moz-user-select: all;
		-ms-user-select: all;
		user-select: all;
	}
</style>
